import React, { useMemo, useState } from "react";
import { apiPost } from "./EmailApi";

function EmailIdeasSection() {
  const [businessName, setBusinessName] = useState("");
  const [emailIdeas, setEmailIdeas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const safeIdeas = useMemo(() => {
    return Array.isArray(emailIdeas) ? emailIdeas.filter(Boolean) : [];
  }, [emailIdeas]);

  const handleGenerate = async () => {
    const safeBusinessName = businessName.trim();

    setMessage("");

    if (!safeBusinessName) {
      setMessage("Please enter your business name.");
      return;
    }

    try {
      setLoading(true);

      const data = await apiPost("/api/email/ideas", {
        businessName: safeBusinessName,
      });

      if (!data?.success) {
        throw new Error(data?.message || "Failed to generate ideas.");
      }

      setEmailIdeas(Array.isArray(data?.data) ? data.data : []);
    } catch (error) {
      setEmailIdeas([]);
      setMessage(error.message || "Failed to generate ideas.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="email-generator-box">
        <input
          type="text"
          placeholder="Enter your business name"
          value={businessName}
          onChange={(event) => setBusinessName(event.target.value)}
          autoComplete="organization"
          aria-label="Business name"
        />

        <button type="button" onClick={handleGenerate} disabled={loading}>
          {loading ? "Generating..." : "Generate Email Ideas"}
        </button>
      </div>

      {message ? <output className="email-error-box">{message}</output> : null}

      {safeIdeas.length > 0 ? (
        <div className="email-ideas-wrap">
          {safeIdeas.map((item) => (
            <div className="email-idea-card" key={item}>
              <h3>{item}</h3>
              <p>Suggested professional email address</p>
            </div>
          ))}
        </div>
      ) : null}
    </>
  );
}

export default EmailIdeasSection;